import type { Translation } from "@/types/translationTypes"

export const ar: Translation = {
  sidebar: {
    home: "الرئيسية",
    profile: "الملف الشخصي",
    enrolledCourses: "الدورات",
    projects: "المشاريع",
    feedbacks: "الملاحظات",
    tickets: "تذاكر الدعم",
    yourCv: "السيرة الذاتية",
    survey: "الاستبيانات",
    freeMaterials: "مكتبة ايراسوفت",
    isNew: "جديد",
  },

  freeMaterialsPage: {
    viewCourse: "عرض",
    enrollIntoCourse: "اشترك",
    freeCourse: "مجاني",
    viewPdf: "عرض المستند",
    watchVideo: "مشاهدة الفيديو",
    paidMaterial: "محتوى مدفوع",
    paidMaterialToast: "هذا المحتوى للمشتركين فقط",
    free: "مجانا",
    completed: "مكتمل",
    markDone: "مكتمل",
    markNotDone: "غير مكتمل",
    ratings: "التقييمات",
    allRatings: "جميع التقييمات",
    myRating: "تقييماتي",
    addReview: "اضف تقييم",
    ratingLabel: "التقييم",
    commentLabel: "التعليق (اختياري)",
    ratingToast: "عليك اتمام 25% على الاقل لاضافة تقييم",
    delete: "هل انت متاكد من حذف التقييم؟",
  },

  advertisements: {
    title: "عرض خاص",
  },

  newTicketModal: {
    subject: "العنوان",
    description: "الوصف",
  },

  courseModalsTitles: {
    courseEdit: "تعديل الدورة",
    courseAdd: "إضافة دورة",
    courseDuplicate: "نسخ الدورة",
    roundNotes: "ملاحظات الدورة",
    mindMap: "خريطة الدورة",
    videoModal: "قائمة الفيديوهات",
    editSocialLinks: "تعديل الروابط الاجتماعية",
    editSkills: "تعديل المهارات",
    video: "الفيديو التعريفي",
  },
  socialLinksModal: {
    errors: {
      url: "يجب أن يكون رابطًا صالحًا",
    },
    data: {
      github: { label: "جيت هاب", placeholder: "أدخل رابط Github" },
      linkedin: { label: "لينكد ان", placeholder: "أدخل رابط Linkedin" },
      behance: { label: "بيهانس", placeholder: "أدخل رابط Behance" },
      facebook: { label: "فيسبوك", placeholder: "أدخل رابط Facebook" },
      youtube: { label: "يوتيوب", placeholder: "أدخل رابط Youtube" },
      stackoverflow: {
        label: "ستاك اوفرفلو",
        placeholder: "أدخل رابط Stackoverflow",
      },
      devto: { label: "ديف تو", placeholder: "أدخل رابط Devto" },
    },
  },
  birthdayBanner: {
    title: "كل سنة و انت طيب!",
    message: "نتمنى لك يوم جميل مليان بالسعادة والنجاح! 🎂",
  },
  buttons: {
    clear: "مسح",
    cancel: "الغاء",
    save: "حفظ",
    edit: "تعديل",
    add: "إضافة",
    upload: "تحميل",
    prev: "السابق",
    next: "التالي",
    login: "تسجيل الدخول",
    seeAll: "اظهار الكل",
    goto: "الذهاب الى",
    ok: "موافق",
    learnMore: "أعرف المزيد",
    send: "ارسل",
    delete: "حذف",
    logout: "تسجيل الخروج",
    back: "عودة للخلف",
    share: "مشاركة",
    download: "تحميل كصورة",
    copyLink: "نسخ الرابط",
    facebook: "فيسبوك",
    twitter: "تويتر",
    linkedin: "لينكد إن",
  },
  skillsModal: {
    errors: {
      exists: "المهارة مطلوبة",
    },
    data: {
      skill: { placeholder: "أدخل المهارة" },
      noData: "لا يوجد بيانات",
    },
  },

  newProjectModal: {
    title: "العنوان",
    description: "الوصف",
    link: "رابط المشروع",
    videoLink: "رابط فيديو المشروع",
    errors: {
      title: "العنوان مطلوب",
      description: "الوصف مطلوب",
      link: "رابط المشروع مطلوب",
      videoLink: "رابط فيديو المشروع مطلوب",
    },
  },

  NotificationModalsTitles: {
    notificationDetails: "تفاصيل الإشعارات",
  },
  enrolledCoursesModalsTitles: {
    feedback: "ملاحظات",
    taskUpload: "تحميل التاسك",
    videoPreview: "مشاهدة الفيديو",
    materialPreview: "مشاهدة المواد الاضافية",
    lectureTasks: "تاسكات المحاضرة",
    lectureProjects: "مشاريع المحاضرة",
    lectureContent: "محتوى المحاضرة",
    lectureMentorSessions: "محاضرات المنتور",
    lectureAdditionalMaterials: "مواد اضافية للمحاضرة",
    attendLecture: "حضور المحاضرة",
    mindMap: "خطة الدورة",
  },

  taskUpload: {
    data: {
      task_url: {
        placeholder: "أدخل رابط التاسك",
        label: "رابط التاسك",
      },
    },
  },

  driveVideoPreview: {
    errors: {
      invalid: "رابط غير صالح",
    },
  },

  additionalMaterialsPreview: {
    errors: {
      invalid: "رابط غير صالح",
    },
  },

  additionalMaterials: {
    pdf: "مستند PDF",
    video: "فيديو",
  },

  lectureContentModal: {
    chapter: "فصل",
    lesson: "درس",
  },

  attendLecture: {
    title: "حضور المحاضرة",
  },
  feedbackModalTitles: {
    feedbacks: "الملاحظات",
  },
  ticketsModalTitles: {
    newTicket: "تذكرة جديدة",
  },
  projectsModalTitles: {
    addProject: "إضافة مشروع",
    editProject: "تعديل المشروع",
  },

  errorPage: {
    title: "عذرا لقد حدث خطأ",
    subtitle: "لا يمكنك الوصول الى الصفحة المطلوبة",
    buttons: {
      home: "العودة الى الصفحة الرئيسية",
    },
  },

  pageTitles: {
    home: "الصفحة الرئيسية",
    profile: "الصفحة الشخصية",
    feedbacks: "الملاحظات",
    projects: "المشاريع",
    tickets: "تذاكر الدعم",
    enrolledCourses: "الكورسات",
    yourCv: "السيرة الذاتية",
    surveys: "الاستبيانات",
    answers: "الاجوبة",
    freeMaterials: "مكتبة ايراسوفت",
  },

  auth: {
    login: {
      title: "تسجيل الدخول",
      subtitle: "تسجيل الدخول لحسابك",
      messages: {
        success: "تم تسجيل الدخول بنجاح",
      },
      data: {
        email: {
          label: "البريد الإلكتروني",
          placeholder: "أدخل البريد الإلكتروني",
        },
        password: {
          label: "كلمة المرور",
          placeholder: "أدخل كلمة المرور",
        },
      },
    },
  },

  achievementFlair: {
    roundLeaderTitle: "تهانينا! أنت تتصدر هذه الدورة!",
    roundLeaderSub: "استمر في العمل الممتاز للبقاء في القمة.",
    topOneTitle: "عمل رائع! أنت أحد طلابنا المميزين (Top One)!",
    topOneSub: "عملك الجاد وتفانيك يظهران نتائج مبهرة.",
    roundLeaderBadge: "متصدر الدورة",
    topOneBadge: "طالب Top One",
    shareTitle: "مشاركة الإنجاز",
    shareMessageRoundLeader:
      "فخور بمشاركة أنني أتصدّر المجموعة {{group}} في كورس {{course}} حالياً في أكاديمية إيراسوفت! 🏆",
    shareMessageTopOne:
      "سعيد بمشاركة أنني أحد الطلاب الـمتفوقين في المجموعة {{group}} بكورس {{course}} في أكاديمية إيراسوفت! 🌟",
  },
  topOneShare: {
    notFound: "لم يتم العثور على الانجاز",
    title: "Top One Achievement",
    academy: "أكاديمية إيراسوفت",
    course: "الكورس",
    round: "الدورة",
    verifiedBy: "تم التحقق من قبل إيراسوفت",
  },
  homePage: {
    feedbacks: {
      title: "الملاحظات",
    },
    absenceAlert: {
      title: "تنبيه الغياب",
      message: "لديك غياب متكرر. يرجى التواصل مع فريق الاوبريشن",
    },
    missedTasksAlert: {
      title: "تنبيه التاسكات",
      message: "لديك تاسكات متأخرة. يرجى تسليمها في اسرع وقت",
    },

    latestLectures: {
      title: "المحاضرات الجديدة",
      startsAt: "تبدأ في",
      joinNow: "انضم الآن",
    },
    topOne: {
      subHeading: "افضل الطلاب في دورات",
    },
    leaderboard: {
      roundRank: "ترتيب الطلاب",
      lecturesDegree: "درجة المحاضرات",
      roundStats: {
        title: "إحصائيات الطالب",
        attendancePieChartTitle: "الحضور",
        avgRatingPieChartTitle: "متوسط التاسكات",
        scorePieChartTitle: "المعدل",
        bonusPieChartTitle: "النقاط الاضافية",
        remaining: "المتبقي",
      },
      barchart: {
        label: "النقاط",
      },
      progress: {
        title: "تقدمك",
        progressUnder50: "تقدمك اقل من 50%",
        reachedHighestBadge: "لقد حصلت على الوسم الاعلى",
        badgeNames: {
          bronze: "برونز",
          silver: "فضي",
          gold: "ذهبي",
          platinum: "بلاتيني",
          diamond: "الماسي",
          topOne: "الاول",
        },
      },
    },
    todaysMeetings: {
      title: "محاضرات اليوم",
      table: {
        no: "رقم",
        lectureName: "اسم المحاضرة",
        joinUrl: "رابط الانضمام",
        startAt: "وقت البداية",
        lectureTask: "تاسك المحاضرة",
        myTask: "التاسك الخاض بي",
        joinTooltip: "انضم",
        taskTooltip: "التاسك",
        submissionTooltip: "تسليم التاسك",
      },
    },
  },

  profilePage: {
    defaults: {
      country: "مصر",
      other: "اخرى",
    },
    title: "البيانات الشخصية",
    data: {
      image: "الصورة الشخصية",
      army_status: {
        label: "الموقف التجنيدي",
        placeholder: "ادخل الموقف التجنيدي",
      },
      name: {
        label: "الاسم",
        placeholder: "ادخل الاسم",
      },
      email: {
        label: "البريد الإلكتروني",
        placeholder: "ادخل البريد الإلكتروني",
      },
      password: {
        label: "كلمة المرور",
        placeholder: "ادخل كلمة المرور",
      },
      phone: {
        label: "الهاتف",
        placeholder: "ادخل الهاتف",
      },
      birthdate: {
        label: "تاريخ الميلاد",
        placeholder: "ادخل تاريخ الميلاد",
      },
      country: {
        label: "الدولة",
        placeholder: "ادخل الدولة",
      },
      city: {
        label: "المدينة",
        placeholder: "ادخل المدينة",
      },
      college: {
        label: "الجامعة",
        placeholder: "ادخل الجامعة",
      },
      profession: {
        label: "التخصص الدراسي",
        placeholder: "التخصص الدراسي",
      },
      type: {
        label: "طالب \\ خريج ",
        placeholder: "",
      },
    },
    socialLinks: {
      title: "روابط التواصل",
    },
    skills: {
      title: "المهارات",
      noData: "لا يوجد مهارات",
    },
    army_statuses: {
      in_progress: "اؤدي الخدمة العسكرية حاليا",
      finished: "انهيت الخدمة العسكرية",
      exempt: "معفي من الخدمة العسكرية",
      postponed: "الخدمة العسكرية مؤجلة",
    },
  },

  feedbacksPage: {
    title: "الملاحظات",
    table: {
      no: "رقم",
      group: "المجموعة",
      lecture: "المحاضرة",
      feedback: "الملاحظات",
    },
  },

  projectsPage: {
    title: "المشاريع",
    table: {
      no: "رقم",
      name: "الاسم",
      description: "الوصف",
      link: "رابط المشروع",
      video: "الفيديو",
      videoTooltip: "فيديو",
      comment: "الملاحظات",
    },
    delete: "حذف المشروع",
  },

  ticketsPage: {
    title: "تذاكر الدعم",
    chatShow: {
      subject: "العنوان",
      description: "الوصف",
      micPermission: "السماح للموقع باستخدام الميكروفون",
      content: { label: "المحتوى", placeholder: "اضف المحتوى" },
      note: { label: "ملاحظة", placeholder: "اضف ملاحظة" },
    },
    table: {
      no: "رقم",
      name: "الاسم",
      subject: "العنوان",
      description: "الوصف",
      status: "الحالة",
      view: "عرض",
      openTooltip: "افتح",
    },
    statuses: {
      new: "جديد",
      pending: "قيد الانتظار",
      inProgress: "قيد التنفيذ",
      closed: "مغلق",
    },
    filters: {
      all: "الكل",
      opened: "مفتوح",
      closed: "مغلق",
      pending: "قيد الانتظار",
      inProgress: "قيد التنفيذ",
    },
    delete: "حذف التذكرة",
    newTicketTooltip: "افتح تذكرة جديدة",
  },

  pagination: {
    data: {
      page: "صفحة",
    },
    errors: {
      invalidPage: "رقم الصفحة خطأ",
    },
  },

  enrolledCoursesPage: {
    lecturesDetails: {
      lectureContent: "محتوى المحاضرة",
      deadlineNotSet: "لا يوجد موعد نهائي",
      taskNotSet: "لا يوجد تاسك",
      attendance: {
        attended: "حاضر",
        absent: "غائب",
        todaysLecture: "محاضرة اليوم",
      },
      lectureVideosTooltip: "فيديوهات المحاضرة",
      taskSubmitTooltip: "تسليم التاسك",
      taskTooltip: "التاسك",
      mySubmissionTooltip: "التسليم الخاص بي",
      uploadTaskTooltip: "تحميل التاسك",
      deadlinePassedTooltip: "انتهى الموعد",
      taskDegree: "تقييم التاسك",
      taskFeedback: "ملاحظات التاسك",
      driveTooltip: "Drive",
      lectureTasksTooltip: "تاسكات المحاضرة",
      lectureProjectsTooltip: "مشاريع المحاضرة",
      lectureAdditionalMaterialsTooltip: "مواد اضافية للمحاضرة",
      lectureContentTooltip: "محتوى المحاضرة",
    },
    videos: {
      noData: "لا يوجد فيديوهات",
      video: "فيديو",
    },
    rounds: {
      attendanceRate: "الحضور",
      taskDegreeRate: "التقييم",
      meetingLink: "رابط المحاضرة",
      viewDetails: "عرض التفاصيل",
      viewPlan: "عرض خطة الدورة",
      lecturesCount: "محاضرة",
      types: {
        online: "اونلاين",
        offline: "اوفلاين",
        hybrid: "هجين",
      },
      status: {
        active: "نشط",
        finished: "منتهي",
      },
    },
  },

  confirm: {
    delete: {
      primary: "حذف",
      secondary: "الغاء",
      message: "هل انت متأكد؟",
      title: "تأكيد الحذف",
    },
    discardChanges: {
      primary: "الغاء",
      secondary: "اكمل التعديل",
      message: "هل تريد الغاء التعديلات؟",
      title: "الغاء التعديلات؟",
    },
    logout: {
      primary: "تسجيل الخروج",
      secondary: "الغاء",
      message: "هل انت متأكد انك تريد تسجيل الخروج؟",
      title: "تسجيل الخروج",
    },
  },

  surveysPage: {
    table: {
      no: "الرقم",
      title: "العنوان",
      description: "الوصف",
    },
    item: {
      seeAnswers: "مشاهدة الاجابات",
      answer: "جاوب الاستبيان",
    },
  },
  surveyAnswerPage: {
    error: {
      data: "فشل تحميل البيانات ❌",
      answerAll: "برجاء الاجابة على جميع الاسئلة قبل الانتقال للجزء التالي ⚠",
    },
    note: "ملاحظات (اختياري)",
    recommend: {
      message: "لاي درجة ترشح ايراسوفت؟",
      low: "(لا ارشح مطلقا)",
      high: "(ارشح بشدة)",
    },

    answerKey: {
      one: "لا اوافق بشدة",
      two: "لا اوافق",
      three: "محايد",
      four: "اوافق",
      five: "اوافق بشدة",
    },
  },

  noMessages: {
    no: "لا يوجد",
    data: "بيانات",
    todaysMeetings: "محاضرات اليوم",
    feedbacks: "ملاحظات",
    projects: "مشاريع",
    tickets: "تذاكر",
    courses: "كورسات",
    surveys: "استبيانات",
    videos: "فيديوهات",
    materials: "مواد اضافية",
    freeMaterials: "مصادر اضافية",
    reviews: "تقييمات",
  },

  breadCrumbs: {
    enrolledCourses: "الكورسات",
    videos: "الفيديوهات",
  },
  audioRecorder: {
    noSupport: "المتصفح الخاص بك لا يدعم تسجيل الصوت",
  },

  notifications: {
    drop: {
      title: "الاشعارات",
      noData: "لا يوجد اشعارات",
    },
  },

  common: {
    back: "عودة للخلف",
    completed: "مكتمل",
    noData: "لا يوجد بيانات",
    course: "الكورس",
    chapter: "الفصل",
    lesson: "الدرس",
  },
}
